import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';

const AgentReferral = () => {

    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const referralCode = queryParams.get('referralCode');

    useEffect(() => {
        // --pick the referal code from queryparams

        const deepLink = `myapp://com.deliva.da?referralCode=${referralCode}`;
        const androidStoreUrl = `https://play.google.com/store/apps/details?id=com.deliva.da`;
        const iosStoreUrl = `https://apps.apple.com/in/app/delivahere-agent/id6502445529`;

        const isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent);

        setTimeout(() => {
            window.location.href = isIOS ? iosStoreUrl : androidStoreUrl;
        }, 5000);

        window.location.href = deepLink;
    }, [])
    return (
        <div class="d-flex justify-content-center align-items-center vh-100">
            <h1 class="text-center">Please wait...</h1>
        </div>

    );
}

export default AgentReferral